import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CookieConsentBanner from "../components/CookieConsentBanner";
import AccessibilityToolbar from "../components/AccessibilityToolbar";
import "./MainLayout.css";
import Contact from "pages/Contact";

const MainLayout: React.FC = () => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  // הגדרת כיוון הטקסט בטעינה הראשונית ובכל שינוי שפה
  React.useEffect(() => {
    document.dir = i18n.language === "he" ? "rtl" : "ltr";

    // Update body class
    document.body.classList.remove("rtl", "ltr");
    document.body.classList.add(i18n.language === "he" ? "rtl" : "ltr");
  }, [i18n.language]);

  return (
    <div className="layout-container">
      <Header />
      <main className="main main-content">
        <Outlet />
      </main>
      <Contact />
      <Footer />
      <div className="footer-links">
        <Link to="/accessibility" className="footer-accessibility-link">
          {t("accessibilityStatementTitle")}
        </Link>
        |
        <Link to="/cancellation-policy" className="footer-accessibility-link">
          {t("cancellationPolicyTitle")}
        </Link>
      </div>
      <CookieConsentBanner />
      <AccessibilityToolbar />
    </div>
  );
};

export default MainLayout;
